import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import api from "../../api";
import { REFRESH_TOKEN, ACCESS_TOKEN } from "../../helpers/constants";
import { useState, useEffect } from "react";
import PageNotFound from "./PageNotFound";
import { fetchUserRolePermissions } from "../../helpers/CompanyId";

function ProtectedRoute({ children, restrict}) {
    console.log("PP:",restrict)
    const [isAuthorized, setIsAuthorized] = useState(null);
    // const [userRole, setUserRole] = useState('');
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() => {
        auth().catch(() => setIsAuthorized(false))
    }, [])

    // useEffect(() => {
    //     const fetchUserRole = async () => {
    //         if (restrict === true) {
    //             const role = await fetchRole();  
    //             console.log("User Role:", role);
    //             setUserRole(role);
    //         }
    //     };
    //     fetchUserRole();
    // }, [restrict]);

    // console.log("UROLE:",userRole);

    useEffect(() => {
        const getUserRolePermissions = async () => {
            try {
                setLoading(true);
                const data = await fetchUserRolePermissions();
                console.log("DD:", data)
                if (data) {
                    setPermissions(data || []);
    
                }
            } catch (err) {
                console.error('Error fetching permissions:', err);
                setError('Failed to fetch user permissions');
            } finally {
                setLoading(false);
            }
        };
    
        getUserRolePermissions();
    }, []); 
    

    


    const refreshToken = async () => {
        const refreshToken = localStorage.getItem(REFRESH_TOKEN);
        console.log("RTOken:",refreshToken)
        try {
            const res = await api.post("/api/token/refresh/", {
                refresh: refreshToken,
            });
            if (res.status === 200) {
                localStorage.setItem(ACCESS_TOKEN, res.data.access)
                setIsAuthorized(true)
            } else {
                setIsAuthorized(false)
            }
        } catch (error) {
            console.log(error);
            setIsAuthorized(false);
        }
    };

    const auth = async () => {
        const token = localStorage.getItem(ACCESS_TOKEN);
        if (!token) {
            setIsAuthorized(false);
            return;
        }
        const decoded = jwtDecode(token);
        const tokenExpiration = decoded.exp;
        const now = Date.now() / 1000;

        if (tokenExpiration < now) {
            await refreshToken();
        } else {
            setIsAuthorized(true);
        }
    };

    if (isAuthorized === null) {
        return <div>Loading...</div>;
    }

    // return isAuthorized ? (
    //     restrict === true &&
    //     !["Admin", "Account Manager", "Super Admin"].includes(userRole) ? (
    //         <PageNotFound />
    //     ) : (
    //         children
    //     )
    // ) : (
    //     <Navigate to="/login" />
    // );

    // return isAuthorized ? (permissions.includes('v-employee') ? children: <PageNotFound/>) : <Navigate to="/login" />;
    
    return isAuthorized ? children: <Navigate to="/login" />;

}

export default ProtectedRoute;